import { FC, RefObject, useState } from 'react';
import styles from './PaymentSelector.module.scss';
import { PaymentType } from '../../../../modules/consume/domain/models/PaymentType';
import { Button } from '@mui/material';
import MoneyInput from '../../../TableMap/components/partialPaymentInput/MoneyInput';
import UseDeviceStore from '../../../../modules/device/store/DeviceStore';
import { useI18n } from '../../../../hooks/useI18n';
import { moneyMaskNumber } from '../../../../services/utils/Money';

export interface IPaymentSelectiorProps {
    paymentType: PaymentType | undefined,
    onChangePaymentType: (paymentType: PaymentType) => void,
    onFocusInput: (inputEvent: RefObject<HTMLInputElement>) => void,
    amountToPay: number
    showCielo?: boolean
}

export const PaymentSelector: FC<IPaymentSelectiorProps> = ({
    paymentType, amountToPay, onChangePaymentType, onFocusInput, showCielo
}) => {
    const { t } = useI18n();
    const [deviceConfig] = UseDeviceStore(state => [state.deviceConfig]);

    const [moneyValue, setMoneyValue] = useState<number>();

    const handlePaymentIcon = (currentPaymentType: PaymentType) => {
        switch (currentPaymentType) {
            case 1:
                return "/assets/img/credit-card.svg"
            case 2:
                return "/assets/img/debit-card.svg"
            case 3:
                return "/assets/img/money.svg"
            case 18:
                return "/assets/img/pix.svg"
            default:
                return "";
        }//TODO: COLOCAR O ENUM
    };

    return (
        <div className={styles.paymentType}>
            <b>{t('paymentLabels.paymentMethod')}</b>
            <div className={styles.buttonContainer}>
                {deviceConfig?.payment.methods.map((payment) => {
                    var _paymentType = payment.type === PaymentType.PIX_OLD_WALLET_DEPRECATED ? 18 : payment.type;
                    return (payment.enabled && (

                        <Button
                            key={_paymentType}
                            size='large'
                            classes={{ outlined: styles.outlined, text: styles.text }}
                            variant={paymentType === _paymentType ? "outlined" : "text"}
                            color='primary'
                            className={styles.button}
                            onClick={() => onChangePaymentType(_paymentType)}
                        >
                            {handlePaymentIcon(_paymentType) && <img alt={t('paymentLabels.payment')} src={handlePaymentIcon(_paymentType)} />}
                            {payment.name}
                        </Button>
                    ))
                })}
                {/* {showCielo && <Button size='large' classes={{ outlined: styles.outlined, text: styles.text }} variant={paymentType === PaymentType.cielo ? "outlined" : "text"} color='primary' className={styles.button} onClick={() => onChangePaymentType(PaymentType.cielo)}>
                    <img width={80} alt={'Cielo'} src='/assets/img/logo-cielo.png' />
                </Button>} */}
                {deviceConfig?.payment.customMethods.map((payment) => payment.enabled && (
                    <Button
                        key={payment.type}
                        size='large'
                        classes={{ outlined: styles.outlined, text: styles.text }}
                        variant={paymentType === payment.type ? "outlined" : "text"}
                        color='primary'
                        className={styles.button}
                        onClick={() => onChangePaymentType(payment.type)}
                    >
                        {handlePaymentIcon(payment.type) && <img alt={t('paymentLabels.payment')} src={handlePaymentIcon(payment.type)} />}
                        {payment.name}
                    </Button>
                ))}
            </div>
            {paymentType === PaymentType.dinheiro &&
                <div className={styles.change}>
                    <h2>
                        {t('paymentLabels.calculateChange')}
                    </h2>
                    <MoneyInput sugestion onFocus={onFocusInput} defaultValue={amountToPay} label={t('paymentLabels.cashValue')} onChange={setMoneyValue} />
                    {!!moneyValue && (moneyValue - amountToPay) > 0 && <div className={styles.result}>
                        <label>{t('paymentLabels.change')}</label> <b>{moneyMaskNumber(moneyValue - amountToPay)}</b>
                    </div>}
                </div>}
        </div>
    );
};
